import { useContext } from "react";
import { defaultLang } from "./LanguageContext";
import englishFlag from "./images/EnglishFlag.svg";
import italianFlag from "./images/ItalianFlag.svg";
export default function ToggleLang() {
  const { lang, setLang } = useContext(defaultLang);

  return lang === "Ita" ? (
    <button
      style={{
        backgroundImage: `url(${italianFlag})`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
      onClick={() => {
        setLang(lang === "Ita" ? "Eng" : "Ita");
      }}
      className='p-2 w-9 h-9 rounded-full duration-300 transition-all bg-[#1E1E1E] outline-none focus:outline-2 focus:outline-[#9499ff]'></button>
  ) : (
    <button
      style={{
        backgroundImage: `url(${englishFlag})`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
      onClick={() => {
        setLang(lang === "Ita" ? "Eng" : "Ita");
      }}
      className='p-2 w-9 h-9 rounded-full duration-300 transition-all bg-[#1E1E1E] outline-none focus:outline-2 focus:outline-[#9499ff]'></button>
  );
}
